var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMacos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.076,
    height: 16,
    viewBox: "0 0 13.076 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:gray;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-901.158 -184.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M901.833,191.158c-1.353,2.166-.493,5.451,1,7.443.747,1,1.5,1.89,2.539,1.89h.059a3.352,3.352,0,0,0,1.178-.289,3.437,3.437,0,0,1,1.4-.305,3.234,3.234,0,0,1,1.328.3,3,3,0,0,0,1.273.281c1.166-.02,1.882-.984,2.514-1.836a7.86,7.86,0,0,0,1.1-2.081l0-.013a.118.118,0,0,0-.07-.148l-.01,0a3.125,3.125,0,0,1-2.026-2.824,3.16,3.16,0,0,1,1.626-2.653l.013-.007a.123.123,0,0,0,.058-.077.113.113,0,0,0-.02-.092,3.9,3.9,0,0,0-2.977-1.491c-.085-.008-.172-.012-.26-.012a5.541,5.541,0,0,0-1.868.43,3.2,3.2,0,0,1-.894.246,3.121,3.121,0,0,1-.926-.249,4.793,4.793,0,0,0-1.632-.382H905.2A4.06,4.06,0,0,0,901.833,191.158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M913.239,184.491a4.566,4.566,0,0,0-3.015,1.546,4.278,4.278,0,0,0-1.083,3.172.163.163,0,0,0,.15.142c.069.006.141.008.212.008a3.862,3.862,0,0,0,2.845-1.459,4.51,4.51,0,0,0,1.06-3.264A.164.164,0,0,0,913.239,184.491Z",
    transform: "translate(-2.162)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMacos);
export default __webpack_public_path__ + "static/media/icon-macos.29590a1437618a47f63ad670b24b225b.svg";
export { ForwardRef as ReactComponent };